import { getDefaultStore, useAtom } from 'jotai';
import { atomWithStorage } from 'jotai/utils';

export const resultsShowTimersAtom = atomWithStorage(
  'results-show-timers',
  false
);
export const reportsShowTimersAtom = atomWithStorage(
  'reports-show-timers',
  false
);

export const useResultsShowTimers = () => useAtom(resultsShowTimersAtom);

export const useReportsShowTimers = () => useAtom(reportsShowTimersAtom);

export function useShowTimers(isActivityInProgress: boolean) {
  const isResultsShowTimers = useResultsShowTimers();
  const isReportsShowTimers = useReportsShowTimers();

  return isActivityInProgress ? isResultsShowTimers : isReportsShowTimers;
}

export function resetShowTimers() {
  const store = getDefaultStore();
  store.set(resultsShowTimersAtom, false);
  store.set(reportsShowTimersAtom, false);
}

export function useCopyShowTimersToReports() {
  const [, setShowTimers] = useReportsShowTimers();
  const [isResultsShowTimers] = useResultsShowTimers();
  return () => setShowTimers(isResultsShowTimers);
}
